/**
 * Created by Daniela on 26/09/2016.
 */
import { Component }   from '@angular/core';

@Component({
    template: require('./grupos-materiais.component.html')
})
export class GruposMateriaisComponent {}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/grupos-materiais/grupos-materiais.component.ts
 **/